import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { PublisherLogoSquare2 } from "../publisher/PublisherLogo";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ContactBookPublisher[]} props.publishers - List of publishers to display
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId[]} props.selectedPublishers - Currently selected publisher IDs
 * @param {function(import("@seabrookstudios/pitch2table-core").PublisherId): void} props.onTogglePublisher - Callback when a publisher is toggled
 */
export const FilterablePublishersList = ({ publishers, selectedPublishers, onTogglePublisher }) => {
  return (
    <>
      <List>
        {publishers.map((publisher) => (
          <ListItemButton key={publisher.id} onClick={() => onTogglePublisher(publisher.id)}>
            <ListItemAvatar>
              <PublisherLogoSquare2 publisher={publisher} width={48} height={48} />
            </ListItemAvatar>
            <ListItemText primary={publisher.name} />
            <ListItemIcon>{selectedPublishers.includes(publisher.id) && <CheckCircle color="success" />}</ListItemIcon>
          </ListItemButton>
        ))}
      </List>
      {publishers.length === 0 && (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <p>No publishers found.</p>
        </div>
      )}
    </>
  );
};
